import { motion } from "framer-motion";

const offerTexts = [
  "🎯 EXCLUSIVE PARTNER OFFER",
  "⚡ 7-DAY DELIVERY GUARANTEED",
  "💎 PREMIUM MVP BUILD",
  "🚀 LIMITED TIME DISCOUNT",
  "✅ 100% SATISFACTION GUARANTEED",
  "🔥 PRIORITY ACCESS",
  "💰 SPECIAL PARTNER PRICING",
  "⏰ OFFER EXPIRES IN 48 HOURS",
];

export const OfferMarquee = () => {
  return (
    <div className="w-full overflow-hidden bg-gradient-to-r from-primary/10 via-primary/20 to-primary/10 py-3 border-y border-primary/20 rounded-lg">
      <motion.div
        className="flex gap-8 whitespace-nowrap"
        animate={{
          x: [0, -1920],
        }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: 20,
            ease: "linear",
          },
        }}
      >
        {[...offerTexts, ...offerTexts, ...offerTexts].map((text, index) => (
          <span
            key={index}
            className="text-foreground font-semibold text-sm md:text-base"
          >
            {text}
          </span>
        ))}
      </motion.div>
    </div>
  );
};
